module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAAVUlEQVRIiWNgGAUkgv9E4tsMDAwstLTgPwMDQxwxBjJisYAaAG4uE5UMxAlGLRi1YAhbwIgHx1NiIawYwAeYGRgYbjDgL0YosoAkMHwjeehYMAoIAgAVQyN6y+R0SAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flag.png
// module id = 442
// module chunks = 0